module.exports = __webpack_public_path__ + "static/media/facebook-icon-color.91fc41e4.png";